import "./hr.component.scss";

import { memo }from "react";

const Hr = props => {
  const {
    className,
    ...other
  } = props;

  return (
    <hr className={`hr-container ${className}`} {...other}/>
  );
};

export default memo(Hr);
